import type { ReactNode } from "react";
import "./Card.css";

interface CardProps {
  title?: string;
  meta?: string;
  children: ReactNode;
  actions?: ReactNode;
  padding?: "none" | "default";
}

export function Card({ title, meta, children, actions, padding = "default" }: CardProps) {
  return (
    <section className={`card ${padding === "none" ? "card--flush" : ""}`}>
      {(title || actions) && (
        <header className="card__header">
          <div>
            {title && <h2 className="card__title">{title}</h2>}
            {meta && <p className="card__meta">{meta}</p>}
          </div>
          {actions && <div className="card__actions">{actions}</div>}
        </header>
      )}
      <div className="card__body">{children}</div>
    </section>
  );
}
